import type { FormEvent } from "react";
import { useState } from "react";
import { Button } from "@pushup/ui";
import { Input } from "@pushup/ui";
import { Label } from "@pushup/ui";
import { Loader2, Lock, User } from "lucide-react";
import { authClient } from "@/lib/auth";

export function SignInForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError(null);
    setIsSubmitting(true);
    const result = await authClient.signIn.email({ email, password });
    setIsSubmitting(false);
    if (result.error) {
      setError(result.error.message ?? "Sign in failed.");
      return;
    }
    window.location.href = "/";
  };

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center px-4">
      <div className="widget widget-auth w-full">
        <div className="widget-body pt-6">
          <h3 className="mb-1 mt-0 text-center font-light text-white">Login to your Web App</h3>
          <p className="widget-auth-info">Use your email to sign in.</p>

          <form onSubmit={handleSubmit} className="mt-4 space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="admin-email" className="text-white/80">
                Email
              </Label>
              <div className="relative">
                <User className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-white/70" />
                <Input
                  id="admin-email"
                  type="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  autoComplete="email"
                  required
                  className="border-0 bg-white/5 pl-9 text-white placeholder:text-white/40 focus-visible:ring-lb-blue"
                  placeholder="Email"
                />
              </div>
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="admin-password" className="text-white/80">
                Password
              </Label>
              <div className="relative">
                <Lock className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-white/70" />
                <Input
                  id="admin-password"
                  type="password"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  autoComplete="current-password"
                  required
                  className="border-0 bg-white/5 pl-9 text-white placeholder:text-white/40 focus-visible:ring-lb-blue"
                  placeholder="Password"
                />
              </div>
            </div>
            {error && <p className="text-sm text-lb-red">{error}</p>}
            <Button
              type="submit"
              className="w-full bg-lb-red text-white hover:bg-lb-red/90"
              disabled={isSubmitting}
            >
              {isSubmitting && <Loader2 className="size-4 animate-spin" />}
              Login
            </Button>
          </form>
        </div>
      </div>
      <footer className="mt-6 text-center text-[13px] text-foreground/40">
        © {new Date().getFullYear()} Light Blue — Pushup Tracker Admin
      </footer>
    </div>
  );
}
